const tripleCardSection = $('#cards-triple-section');
const tripleCards = tripleCardSection.find('.descriptor-title-card');
const tripleCardBtn = tripleCardSection.find('.button-parent');

const tripleCardInAnimtion = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const tripleCardTL = gsap.timeline({
    paused: true,
  });

  tripleCardTL.add(
    animateSectionTopperIn({
      sectionParent: tripleCardSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );


  tripleCardTL.add(elementInAnimationYWOpacity(tripleCards.slice(0, 4), '100%', 1, 1, 1, 0, 0, 0.1).play(), 0)
  addBtnAnimation(tripleCardBtn, 50, true);

  return tripleCardTL;
};

const initEmbla = () => {
  if (isDesktop() || isTablet()) {
    const embla = tripleCardSection.find('.embla');
    const viewport = embla.find('.embla__viewport');
    if (!window.EmblaCarousel || !viewport.length) {
      return;
    }
    const OPTIONS = { align: 'start', dragFree: true, loop: true };
    const plugins = window.EmblaCarouselAutoScroll
      ? [EmblaCarouselAutoScroll({ speed: 1, stopOnMouseEnter: true, stopOnInteraction: false })]
      : [];
    const emblaApi = EmblaCarousel(viewport.get(0), OPTIONS, plugins);
  }
};

const initTripleCard = () => {
  initEmbla();
  if (isDesktop()){
    const tripleCardTL = tripleCardInAnimtion();
    ScrollTrigger.create({
      trigger: tripleCardSection,
      start: 'top top+=120%',
      end: 'top top',
      once: true,
      onEnter: () => {
        //tripleCardTL.play();
      },
      onUpdate: (self) => {
        tripleCardTL.progress(self.progress);
      },
    });
  }
}

/*
$(window).on('load', () => {
  initTripleCard();
});
*/

addSectionObserver(tripleCardSection, initTripleCard);
